<template>
  <section
    class="pb-[60px] xl:pb-[140px] h-[360px] lg:h-[500px]"
    id="start-trading"
  >
    <div class="h-full container">
      <div
        class="w-full h-full flex-y-center flex-col justify-center gap-6 relative trading-bg p-4 lg:p-8 rounded-3xl overflow-hidden"
      >
        <div
          class="absolute w-[800px] -left-28 -top-10 rotate-[56deg] opacity-40"
        >
          <img src="/landing/hero-bg.webp" alt="Frame" class="w-full" />
        </div>
        <div
          class="flex-y-center flex-col justify-center text-center space-y-2 max-w-[660px] z-10"
        >
          <h3
            class="text-[28px] lg:text-[48px] leading-[28px] lg:leading-[48px] text-white font-bold"
          >
            {{ $t("landing.start_trading.title") }}
          </h3>
          <p class="text-white text-base lg:text-lg">
            {{ $t("landing.start_trading.description") }}
          </p>
        </div>
        <RouterLink to="/auth/register">
          <Button
            :text="$t('landing.start_trading.button')"
            variant="primary"
            size="lg"
            class="!px-16"
          />
        </RouterLink>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import Button from "@/modules/Landing/components/Base/Button/Button.vue";
</script>

<style scoped>
.trading-bg {
  background: linear-gradient(
    270deg,
    #111c21 0%,
    #152928 13%,
    #234b3b 36%,
    #38835a 68%,
    #50c27e 100%
  );
}
</style>
